import React, { useEffect } from "react";
import styled from "styled-components";
import CO from "../../images/CoF.jpeg";
import CO1 from "../../images/cof1.jpg";
import Aos from "aos";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const FoundersWrapper = styled.section`
  padding: 80px 20px;
  background: #010606;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const SectionTitle = styled.h2`
  font-size: 42px;
  color: #fff;
  text-align: center;
  margin-bottom: 60px;
  font-weight: 700;
  font-family: "Montserrat", sans-serif;

  span {
    color: #18e68e;
  }

  @media screen and (max-width: 768px) {
    font-size: 32px;
    margin-bottom: 40px;
  }
`;

const FoundersContainer = styled.div`
  display: flex;
  gap: 50px;
  max-width: 1400px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 1024px) {
    gap: 30px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const FounderCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 600px;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 40px;
  }
`;

const FounderImageWrapper = styled.div`
  width: 350px;
  height: 450px;
  margin-bottom: 30px;

  @media screen and (max-width: 768px) {
    width: 300px;
    height: 400px;
  }

  @media screen and (max-width: 480px) {
    width: 250px;
    height: 350px;
  }
`;

const FounderImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 130px 0 130px 0;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 24px rgba(24, 230, 142, 0.3);
  }

  @media screen and (max-width: 768px) {
    border-radius: 80px 0 80px 0;
  }

  @media screen and (max-width: 480px) {
    border-radius: 50px 0 50px 0;
  }
`;

const FounderName = styled.h3`
  font-size: 28px;
  color: #18e68e;
  font-weight: 700;
  margin-bottom: 10px;
  font-family: "Montserrat", sans-serif;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
`;

const FounderRole = styled.h4`
  font-size: 20px;
  color: #fff;
  font-weight: 600;
  margin-bottom: 20px;
  font-family: "Open Sans", sans-serif;
  opacity: 0.9;

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
`;

const FounderBio = styled.p`
  font-size: 16px;
  color: #fff;
  line-height: 1.8;
  font-family: "Open Sans", sans-serif;
  opacity: 0.85;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 15px;
  }
`;

const FounderSection = ({ isRTL }) => {
  const { t } = useTranslation();

  FounderSection.propTypes = {
    isRTL: PropTypes.bool.isRequired,
  };

  useEffect(() => {
    Aos.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <FoundersWrapper>
      <SectionTitle data-aos="fade-up">
        Meet Our <span>Co-Founders</span>
      </SectionTitle>

      <FoundersContainer className={isRTL ? "arabe" : ""}>
        {/* First Co-Founder */}
        <FounderCard data-aos="fade-right">
          <FounderImageWrapper>
            <FounderImage src={CO} alt="Co-Founder 1" />
          </FounderImageWrapper>
          <FounderName>{t("Founder.name")}</FounderName>
          <FounderRole>{t("Founder.title")}</FounderRole>
          <FounderBio>{t("Founder.description")}</FounderBio>
        </FounderCard>

        {/* Second Co-Founder */}
        <FounderCard data-aos="fade-left">
          <FounderImageWrapper>
            <FounderImage src={CO1} alt="Co-Founder 2" />
          </FounderImageWrapper>
          <FounderName>{t("Founder.name1")}</FounderName>
          <FounderRole>{t("Founder.title1")}</FounderRole>
          <FounderBio>{t("Founder.description1")}</FounderBio>
        </FounderCard>
      </FoundersContainer>
    </FoundersWrapper>
  );
};

export default FounderSection;
